import TYPE from 'redhotpie-shared-lib/constants/newFeed';
import Immutable, { ImmutableObject } from 'seamless-immutable';
import * as types from '../constants/actionTypes';
import { CATEGORY_ID } from '../constants/category';
import { APPROVAL_STATUS, EVENT_TYPE, JOIN_GROUP_STATUS, TYPE_NOTIFICATION } from '../constants/constants';
import initialState from './initialState';
import { updateStatusOfGroupData } from './newFeedReducer';
import { IContentItem } from '../interfaces/ICommunity';
import { IGroupContentItem } from 'redhotpie-shared-lib/types/clubProfile';
import { IContentItemEvent } from 'redhotpie-shared-lib/interfaces/ICommunity';
import { IEventUser } from 'redhotpie-shared-lib/interfaces/IEvent';
import { IGroupActivity, IRecentActivity, IGroupState } from '../types/group';
import Feed from 'redhotpie-shared-lib/models/newFeedItem.ts';
import _ from 'lodash';

interface IAction {
  type: string;
  data?: any;
  params?: any;
  typeData?: any;
  paginationInfo?: any;
  categoryId?: any;
  key?: any;
  [key: string]: any;
}

export default function groupReducer(
  state: ImmutableObject<IGroupState> = initialState.groupState,
  action: IAction
): ImmutableObject<IGroupState> {
  switch (action.type) {
    case types.PATCH_ACTION_NOTIFICATION_SUCCESS: {
      let { dataGroupJoinRequest } = Immutable.asMutable(state);
      const { totalGroupJoinRequest } = Immutable.asMutable(state);
      if (action.typeData === TYPE_NOTIFICATION.REQUEST_TO_JOIN) {
        dataGroupJoinRequest = dataGroupJoinRequest.filter((item, index) => index !== action.params.index);
        return state.merge({
          dataGroupJoinRequest,
          totalGroupJoinRequest: totalGroupJoinRequest - 1,
        });
      }
      return state;
    }
    case types.GET_USER_SEARCH_SETTINGS_SUCCESS: {
      const { data } = action;
      const { filtersGroupSearch, defaultFilter } = Immutable.asMutable(state);
      const updateObject = {
        filtersGroupSearch: {
          ...filtersGroupSearch,
          searchRadius: data.filters.searchRadius,
          location: data.filters.location,
        },
        defaultFilter: {
          ...defaultFilter,
          searchRadius: data.filters.searchRadius,
          location: data.filters.location,
        },
        isGetUserSearchSetting: true,
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_GROUP_POPULAR_SEARCH_SUCCESS: {
      const updateObj = {
        dataPopularSearch:
          !action.paginationInfo.page || action.paginationInfo.page < 2
            ? action.data
            : [...state.dataPopularSearch.asMutable(), ...action.data],
        popularPagingInfo: action.paginationInfo,
        isLoadingDataPopularSearch: false,
        // as new changes, we don't need this field anymore, because new API /Club/Suggested have not pagination, page size.
        // and have not filter search param too
        // just leave it here, and dot not remove to avoid any conflict
        searchPaginationInfo: {
          ...state.searchPaginationInfo,
          page: action.paginationInfo.page,
          size: action.paginationInfo.size,
          isHasMore: action.paginationInfo.page * action.paginationInfo.size < action.paginationInfo.total,
        },
      };
      return state.merge({ ...updateObj });
    }

    // as new changes, we use below action type to store data, param search, pagination information when search data in:
    // desktop Popular tab,
    // and Suggested view mobile
    case types.GET_GROUP_DESKTOP_POPULAR_SEARCH_SUCCESS: {
      const updateObj = {
        dataDesktopPopularSearch:
          !action.paginationInfo.page || action.paginationInfo.page < 2
            ? action.data
            : [...state.dataDesktopPopularSearch.asMutable(), ...action.data],
        desktopPopularPagingInfo: action.paginationInfo,
        isLoadingDataDesktopPopularSearch: false,
        desktopSearchPaginationInfo: {
          ...state.desktopSearchPaginationInfo,
          page: action.paginationInfo.page,
          size: action.paginationInfo.size,
          isHasMore: action.paginationInfo.page * action.paginationInfo.size < action.paginationInfo.total,
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_GROUP_DETAIL_SUCCESS: {
      const { dataGroupDetail } = Immutable.asMutable(state);
      console.log('action.data', action.data);
      const updateObj = {
        dataGroupDetail: { ...dataGroupDetail, ...action.data, joinedUsers: dataGroupDetail.joinedUsers },
        isLoadingDataGroupDetail: false,
        isLoadedDataGroupDetail: true,
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_GROUP_JOINED_USERS_SUCCESS: {
      const { dataGroupDetail } = Immutable.asMutable(state);
      const { data, paginationInfo } = action.data;
      const newDataGroupDetail = { ...dataGroupDetail.asMutable() };
      newDataGroupDetail.joinedUsers =
        paginationInfo.page === 1 || paginationInfo.page === 0 ? data : [...dataGroupDetail.joinedUsers.asMutable(), ...data];
      newDataGroupDetail.unfilteredJoinedUsers = !action.params ? data : dataGroupDetail.unfilteredJoinedUsers?.asMutable();
      newDataGroupDetail.unfilteredTotalJoinedUser = !action.params ? paginationInfo.totalItems : dataGroupDetail.unfilteredTotalJoinedUser;
      newDataGroupDetail.isLoadingJoinedUsers = false;
      newDataGroupDetail.isHasMoreJoinedUsers = paginationInfo.page !== paginationInfo.totalPages;
      newDataGroupDetail.pageJoinedUsers = paginationInfo.page === 1 ? 2 : dataGroupDetail.pageJoinedUsers + 1;
      newDataGroupDetail.totalJoinedUser = paginationInfo.totalItems;
      return state.merge({
        dataGroupDetail: newDataGroupDetail,
        isLoadingDataGroupDetail: false,
      });
    }
    case types.GET_GROUP_VOTE_COMMENTS_SUCCESS: {
      const { voteComments } = state;
      return state.merge({
        isLoadingVoteComments: false,
        pageNumberVoteComments: action.params.page,
        isHasMoreVoteComments: action.data.comments.length === action.params.size,
        voteComments:
          !action.params.page || action.params.page < 2 ? action.data.comments : [...voteComments.asMutable(), ...action.data.comments],
        totalVoteComments: action.data.totalItem || 0,
        sizeNumberVoteComments: action.params.size,
      });
    }
    case types.GET_GROUP_EVENTS_SUCCESS: {
      const { clubEvt, clubPastEvt } = state;
      const { page, type, size } = action.params;
      let updateObj = {};
      try {
        if (type === 'Past') {
          updateObj = {
            isLoadingClubPastEvt: false,
            pageNumberClubPastEvt: page,
            isHasMoreClubPastEvt: action.data.length === size,
            clubPastEvt: page === 1 ? action.data : [...clubPastEvt.asMutable(), ...action.data],
            totalClubPastEvt: action.total || 0,
          };
        } else {
          updateObj = {
            isLoadingClubEvt: false,
            pageNumberClubEvt: page,
            isHasMoreClubEvt: action.data.length === size,
            clubEvt: page === 1 ? action.data : [...clubEvt.asMutable(), ...action.data],
            totalClubEvt: action.total || 0,
          };
        }
      } catch (error) {
        console.log(error);
      }
      return state.merge({ ...updateObj });
    }
    case types.GET_GROUP_PHOTOS_SUCCESS: {
      const {
        photos: { data },
      } = state;
      const updateObj = {
        isLoadingGroupPhotos: false,
        photos: {
          data: !action.paginationInfo.page || action.paginationInfo.page < 2 ? action.data : [...data.asMutable(), ...action.data],
          paginationInfo: {
            ...action.paginationInfo,
            isHasMore: action.paginationInfo.page < action.paginationInfo.totalPages,
          },
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_GROUP_ALERT_SUCCESS: {
      return state.set('alerts', action.data);
    }
    case types.GET_GROUP_VIDEOS_SUCCESS: {
      const {
        videos: { data },
      } = state;
      const updateObj = {
        isLoadingGroupVideos: false,
        videos: {
          data: !action.paginationInfo.page || action.paginationInfo.page < 2 ? action.data : [...data.asMutable(), ...action.data],
          paginationInfo: action.paginationInfo,
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_GROUP_ALBUMS_SUCCESS: {
      const {
        albums: { data },
      } = state;
      const updateObj = {
        isLoadingGroupAlbums: false,
        albums: {
          data: !action.paginationInfo.page || action.paginationInfo.page < 2 ? action.data : [...data.asMutable(), ...action.data],
          paginationInfo: action.paginationInfo,
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_GROUP_ACTIVITY_SUCCESS: {
      const {
        activity: { data },
      } = state;
      const updateObj = {
        isLoadingGroupActivity: false,
        activity: {
          data: !action.paginationInfo.page || action.paginationInfo.page < 2 ? action.data : [...data.asMutable(), ...action.data],
          paginationInfo: action.paginationInfo,
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_MY_GROUP_SUCCESS: {
      const updateObj = {
        dataMyGroup: action.data,
        isLoadingDataMyGroup: false,
        loadedDataMyGroup: true,
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_JOINED_GROUP_SUCCESS: {
      const updateObj = {
        dataJoinedGroup: action.data,
        isLoadingDataJoinedGroup: false,
        loadedDataJoinedGroup: true,
      };
      return state.merge({ ...updateObj });
    }
    case types.MERGE_DATA_GROUP: {
      return state.merge(action.data);
    }
    case types.UPDATE_DATA_GROUP: {
      return state.setIn([...action.key], action.data);
    }

    case types.GET_LIST_ENTITIES_SUCCESS: {
      const { filters, defaultMemberFilters, memberFilters, defaultSuggestedMemberFilters, suggestedMemberFilters, suggestedUsersFilter } =
        state;
      let updateObject = {};
      if (action.categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
        updateObject = {
          filters: {
            ...filters.asMutable(),
            showMeMemberType: {
              contentTabs: [
                {
                  data: action.data.items,
                },
              ],
            },
          },
          defaultMemberFilters: {
            ...defaultMemberFilters.asMutable(),
            showMeMemberType: {
              contentTabs: [
                {
                  data: action.data.items,
                },
              ],
            },
          },
          memberFilters: {
            ...memberFilters.asMutable(),
            showMeMemberType: {
              contentTabs: [
                {
                  data: action.data.items,
                },
              ],
            },
          },
          showMeMemberType: {
            contentTabs: [
              {
                data: action.data.items,
              },
            ],
          },
          suggestedMemberFilters: {
            ...suggestedMemberFilters.asMutable(),
            showMeMemberType: {
              contentTabs: [
                {
                  data: action.data.items,
                },
              ],
            },
          },
          defaultSuggestedMemberFilters: {
            ...defaultSuggestedMemberFilters.asMutable(),
            showMeMemberType: {
              contentTabs: [
                {
                  data: action.data.items,
                },
              ],
            },
          },
          suggestedUsersFilter: {
            ...suggestedUsersFilter.asMutable(),
            memberTypes: action.data.items,
            defaultMemberTypes: action.data.items,
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.JOIN_A_GROUP_SUCCESS: {
      const { dataPopularSearch, dataDesktopPopularSearch, dataGroupDetail, recommendedGroups, invitesReceived, groupRecentActivity } =
        state;
      const newData = dataPopularSearch.asMutable().map(itm => {
        if (itm.clubID.toString() === action.data.clubId.toString()) {
          const isPrivate = itm.joinSettings.privacyType === 'Private';
          const joinStatus =
            action.data.status || (isPrivate || action.data.isInvited ? JOIN_GROUP_STATUS.APPROVED : JOIN_GROUP_STATUS.PENDING);
          return {
            ...itm.asMutable(),
            joinSettings: {
              ...itm.joinSettings,
              joinStatus: joinStatus,
            },
          };
        }
        return itm;
      });
      const newDataDesktopPopularSearch = dataDesktopPopularSearch.asMutable().map(itm => {
        if (itm.clubID.toString() === action.data.clubId.toString()) {
          const isPrivate = itm.joinSettings.privacyType === 'Private';
          const joinStatus =
            action.data.status || (isPrivate || action.data.isInvited ? JOIN_GROUP_STATUS.APPROVED : JOIN_GROUP_STATUS.PENDING);
          return {
            ...itm.asMutable(),
            joinSettings: {
              ...itm.joinSettings,
              joinStatus: joinStatus,
            },
          };
        }
        return itm;
      });
      const newRecommendedGroups = recommendedGroups.asMutable().map(itm => {
        if (itm.clubID.toString() === action.data.clubId.toString()) {
          return {
            ...itm.asMutable(),
            joinSettings: {
              ...itm.joinSettings,
              joinStatus: action.data.status || JOIN_GROUP_STATUS.PENDING,
            },
          };
        }
        return itm;
      });
      if (dataGroupDetail && dataGroupDetail.detail?.clubID.toString() === action.data.clubId.toString()) {
        const isPrivate = dataGroupDetail.joinSettings.privacyType === 'Private';
        const joinStatus =
          action.data.status || (isPrivate || action.data.isInvited ? JOIN_GROUP_STATUS.APPROVED : JOIN_GROUP_STATUS.PENDING);
        state = state.setIn(['dataGroupDetail', 'joinSettings', 'joinStatus'], joinStatus);
      }
      const newInvitesReceived = invitesReceived.data.filter(itm => itm.parentId.toString() !== action.data.clubId.toString());

      state = updateStatusOfGroupData(state, {
        data: groupRecentActivity.data.asMutable(),
        clubId: action.data.clubId,
        fieldName: ['groupRecentActivity', 'data'],
        joinStatus: action.data.status || (action.data.isInvited ? JOIN_GROUP_STATUS.APPROVED : JOIN_GROUP_STATUS.PENDING),
      });

      return state.merge({
        dataPopularSearch: newData,
        dataDesktopPopularSearch: newDataDesktopPopularSearch,
        recommendedGroups: newRecommendedGroups,
        invitesReceived: {
          ...invitesReceived,
          data: newInvitesReceived,
          total: newInvitesReceived.length !== invitesReceived.data.length ? invitesReceived.total - 1 : invitesReceived.total,
        },
      });
    }
    case types.LEAVE_A_GROUP_SUCCESS: {
      const { dataPopularSearch, dataDesktopPopularSearch, dataGroupDetail, recommendedGroups, dataJoinedGroup, groupRecentActivity } =
        Immutable.asMutable(state);
      const newData = dataPopularSearch.map(itm => {
        if (itm.clubID.toString() === action.data.clubId.toString()) {
          return {
            ...itm,
            joinSettings: {
              ...itm.joinSettings,
              joinStatus: JOIN_GROUP_STATUS.NOTJOINED,
            },
          };
        }
        return itm;
      });
      const newDataDesktopPopularSearch = dataDesktopPopularSearch.map(itm => {
        if (itm.clubID.toString() === action.data.clubId.toString()) {
          return {
            ...itm,
            joinSettings: {
              ...itm.joinSettings,
              joinStatus: JOIN_GROUP_STATUS.NOTJOINED,
            },
          };
        }
        return itm;
      });
      const newRecommendedGroups = recommendedGroups.map(itm => {
        if (itm.clubID.toString() === action.data.clubId.toString()) {
          return {
            ...itm,
            joinSettings: {
              ...itm.joinSettings,
              joinStatus: JOIN_GROUP_STATUS.NOTJOINED,
            },
          };
        }
        return itm;
      });
      const newDataJoinedGroup = dataJoinedGroup.filter(itm => itm.clubID.toString() !== action.data.clubId.toString());
      if (dataGroupDetail && dataGroupDetail.detail?.clubID.toString() === action.data.clubId.toString()) {
        state = state.setIn(['dataGroupDetail', 'joinSettings', 'joinStatus'], JOIN_GROUP_STATUS.NOTJOINED);
      }

      state = updateStatusOfGroupData(state, {
        data: groupRecentActivity.data,
        clubId: action.data.clubId,
        fieldName: ['groupRecentActivity', 'data'],
        joinStatus: JOIN_GROUP_STATUS.NOTJOINED,
      });
      return state
        .set('dataPopularSearch', newData)
        .set('dataDesktopPopularSearch', newDataDesktopPopularSearch)
        .set('recommendedGroups', newRecommendedGroups)
        .set('dataJoinedGroup', newDataJoinedGroup);
      // return state.merge({
      //   dataPopularSearch: newData,
      //   dataDesktopPopularSearch: newDataDesktopPopularSearch,
      //   recommendedGroups: newRecommendedGroups,
      //   dataJoinedGroup: newDataJoinedGroup,
      // });
    }
    case types.BLOCK_A_GROUP_SUCCESS: {
      const { dataPopularSearch, dataDesktopPopularSearch, recommendedGroups, dataJoinedGroup, invitesReceived } =
        Immutable.asMutable(state);
      const newData = dataPopularSearch.filter(itm => itm.clubID !== action.data);
      const newDataDesktopPopularSearch = dataDesktopPopularSearch.filter(itm => itm.clubID !== action.data);
      const newRecommendedGroups = recommendedGroups.filter(itm => itm.clubID !== action.data);
      const newDataJoinedGroup = dataJoinedGroup.filter(itm => itm.clubID !== action.data);
      const newDataInvitesReceived = invitesReceived.data.filter(i => i.parentId !== action.data);
      return state.merge({
        dataPopularSearch: newData,
        dataDesktopPopularSearch: newDataDesktopPopularSearch,
        recommendedGroups: newRecommendedGroups,
        dataJoinedGroup: newDataJoinedGroup,
        invitesReceived: { ...invitesReceived, data: newDataInvitesReceived },
      });
    }
    case types.POST_UPDATE_MEDIA_COMMENT_SUCCESS: {
      const { photos, videos, albums, albumDetail, postDetail, activity, groupRecentActivity } = Immutable.asMutable(state);
      const { data } = action;
      let updateObj = {};
      if (data.parentType === 'Post') {
        let _postDetail = JSON.parse(JSON.stringify(postDetail));
        let _activity = JSON.parse(JSON.stringify(activity));
        let _groupRecentActivity = JSON.parse(JSON.stringify(groupRecentActivity));
        const commentCount = data.commentCount;
        const activityIndex = activity?.data?.findIndex(item => (item.contentItem as IContentItem)?.id === data.parentId) || -1;
        const groupRecentActivityIndex =
          groupRecentActivity?.data?.findIndex(item => (item.contentItem as IContentItem)?.id === data.parentId) || -1;
        if (activityIndex !== -1) {
          if (_activity.data[activityIndex].contentItem.media[data.objIndex]) {
            _activity.data[activityIndex].contentItem.media[data.objIndex].communityAction.commentCount = data.isDelete
              ? commentCount - 1
              : commentCount + 1;
          }
        }
        if (groupRecentActivityIndex !== -1) {
          if (_groupRecentActivity.data[groupRecentActivityIndex].contentItem.media[data.objIndex]) {
            _groupRecentActivity.data[groupRecentActivityIndex].contentItem.media[data.objIndex].communityAction.commentCount =
              data.isDelete ? commentCount - 1 : commentCount + 1;
          }
        }
        if (_postDetail?.contentItem?.id === data.parentId) {
          if (_postDetail.contentItem.media[data.objIndex]) {
            _postDetail.contentItem.media[data.objIndex].communityAction.commentCount = data.isDelete ? commentCount - 1 : commentCount + 1;
          }
        }
        updateObj = {
          ...updateObj,
          postDetail: _postDetail,
          activity: _activity,
          groupRecentActivity: _groupRecentActivity,
        };
      }
      if (data.objType === 'Photo' && data.objIndex !== undefined) {
        let _photos = JSON.parse(JSON.stringify(photos));
        if (_photos.data[data.objIndex]) {
          let commentCount = _photos.data[data.objIndex].communityAction.commentCount;
          _photos.data[data.objIndex].communityAction.commentCount = data.isDelete ? commentCount - 1 : commentCount + 1;
          updateObj = {
            photos: _photos,
          };
        }
      }
      if (data.objType === 'Video' && data.objIndex !== undefined) {
        let _videos = JSON.parse(JSON.stringify(videos));
        if (_videos.data[data.objIndex]) {
          let commentCount = _videos.data[data.objIndex].communityAction.commentCount;
          _videos.data[data.objIndex].communityAction.commentCount = data.isDelete ? commentCount - 1 : commentCount + 1;
          updateObj = {
            videos: _videos,
          };
        }
      }
      if (data.objType === 'Album') {
        let _albums = JSON.parse(JSON.stringify(albums));
        let _albumDetail = JSON.parse(JSON.stringify(albumDetail));
        if (data.objIndex !== undefined && data.objIndex !== null) {
          if (_albums.data[data.objIndex]) {
            let commentCount = _albums.data[data.objIndex].contentItem.replyCount;
            _albums.data[data.objIndex].contentItem.replyCount = data.isDelete ? commentCount - 1 : commentCount + 1;
            updateObj = {
              ...updateObj,
              albums: _albums,
            };
          }
        }
        if (data.id === _albumDetail.clubAlbumID) {
          let commentCount = _albumDetail.replyCount;
          _albumDetail.replyCount = data.isDelete ? commentCount - 1 : commentCount + 1;
          _albumDetail.paginationInfoComments.totalItems = data.isDelete ? commentCount - 1 : commentCount + 1;
          if (data.comment) {
            const comments = [..._albumDetail.comments];
            if (data.commentParentID) {
              const parentCommentIndex = comments.findIndex(comment => comment.commentId === data.commentParentID);
              if (parentCommentIndex !== -1) {
                if (!comments[parentCommentIndex].replies) {
                  comments[parentCommentIndex].replies = [];
                }
                comments[parentCommentIndex].replies.unshift(data.comment);
              }
            } else {
              comments.unshift(data.comment);
            }

            _albumDetail.comments = comments;
          }
          updateObj = {
            ...updateObj,
            albumDetail: _albumDetail,
          };
        }
      }
      return state.merge({ ...updateObj });
    }
    // case types.UPDATE_MEDIA_LIKE_SUCCESS: {
    //   const { photos, videos, albums, albumDetail, postDetail, activity, groupRecentActivity } = Immutable.asMutable(state);
    //   const { data } = action;
    //   let _albums = JSON.parse(JSON.stringify(albums));
    //   let _activity = JSON.parse(JSON.stringify(activity));
    //   let _albumDetail = JSON.parse(JSON.stringify(albumDetail));
    //   let _photos = JSON.parse(JSON.stringify(photos));
    //   let _videos = JSON.parse(JSON.stringify(videos));
    //   let _postDetail = JSON.parse(JSON.stringify(postDetail));
    //   let _groupRecentActivity = JSON.parse(JSON.stringify(groupRecentActivity));
    //   const isLiked = !data.isLiked;
    //   const likeCount = data.isLiked ? data.likeCount - 1 : data.likeCount + 1;
    //   let updateObj = {};
    //   if (data.parentType === 'Post') {
    //     // when Like a Media in post should like post and update media like count
    //     const activityIndex = _activity.data.findIndex(item => item.contentItem.id === data.parentId) || -1;
    //     const groupRecentActivityIndex = _groupRecentActivity?.data?.findIndex(item => item.contentItem.id === data.parentId) || -1;
    //     // If the post is available in group recent activity
    //     if (groupRecentActivityIndex !== -1) {
    //       if (_groupRecentActivity.data[groupRecentActivityIndex].contentItem.media[data.objIndex]) {
    //         // Update Media Like Count and Like Status in Group Recent Activity
    //         _groupRecentActivity.data[groupRecentActivityIndex].contentItem.media[data.objIndex].communityAction.isLiked = isLiked;
    //         _groupRecentActivity.data[groupRecentActivityIndex].contentItem.media[data.objIndex].communityAction.likeCount = likeCount;
    //         // Update Post Like Count and Like Status in Group Recent Activity
    //         _groupRecentActivity.data[groupRecentActivityIndex].contentItem.likeCount = _groupRecentActivity.data[groupRecentActivityIndex]
    //           .contentItem.isMemberLike
    //           ? _groupRecentActivity.data[groupRecentActivityIndex].contentItem.likeCount - 1
    //           : _groupRecentActivity.data[groupRecentActivityIndex].contentItem.likeCount + 1;
    //         _groupRecentActivity.data[groupRecentActivityIndex].contentItem.isMemberLike = isLiked;
    //       }
    //     }
    //     // If the post is available in activity
    //     if (activityIndex !== -1) {
    //       if (_activity.data[activityIndex].contentItem.media[data.objIndex]) {
    //         // Update Media Like Count and Like Status in Activity
    //         _activity.data[activityIndex].contentItem.media[data.objIndex].communityAction.isLiked = isLiked;
    //         _activity.data[activityIndex].contentItem.media[data.objIndex].communityAction.likeCount = likeCount;
    //         // Update Post Like Count and Like Status in Activity
    //         _activity.data[activityIndex].contentItem.likeCount = _activity.data[activityIndex].contentItem.isMemberLike
    //           ? _activity.data[activityIndex].contentItem.likeCount - 1
    //           : _activity.data[activityIndex].contentItem.likeCount + 1;
    //         _activity.data[activityIndex].contentItem.isMemberLike = isLiked;
    //       }
    //     }
    //     // If the post is available in post detail
    //     if (_postDetail?.contentItem?.id.toString() === data.parentId.toString()) {
    //       let mediaIndex = data.objIndex;
    //       if (!mediaIndex || mediaIndex < 0) {
    //         mediaIndex = postDetail.contentItem.media.findIndex((itm: any) => itm.id === data.id);
    //       }
    //       if (_postDetail.contentItem.media[mediaIndex]) {
    //         _postDetail.contentItem.media[mediaIndex].communityAction.likeCount = likeCount;
    //         _postDetail.contentItem.media[mediaIndex].communityAction.isLiked = isLiked;
    //       }
    //       if (isLiked) {
    //         _postDetail.contentItem.likeCount = _postDetail.contentItem.isMemberLike
    //           ? _postDetail.contentItem.likeCount
    //           : _postDetail.contentItem.likeCount + 1;
    //         _postDetail.contentItem.isMemberLike = true;
    //       }
    //     }
    //     updateObj = {
    //       ...updateObj,
    //       postDetail: _postDetail,
    //       activity: _activity,
    //       groupRecentActivity: _groupRecentActivity,
    //     };
    //   }
    //   if (data.objType === 'Photo' && data.objIndex !== undefined) {
    //     if (_photos.data[data.objIndex]) {
    //       _photos.data[data.objIndex].communityAction.likeCount = likeCount;
    //       _photos.data[data.objIndex].communityAction.isLiked = isLiked;
    //       updateObj = {
    //         ...updateObj,
    //         photos: _photos,
    //       };
    //     }
    //     if (data.parentId) {
    //       const albumIndex = _albums.data.findIndex(item => item.contentItem.id == data.parentId);
    //       if (albumIndex > -1) {
    //         if (!_albums.data[albumIndex].contentItem.isMemberLike) {
    //           _albums.data[albumIndex].contentItem.likeCount = _albums.data[albumIndex].contentItem.likeCount + 1;
    //           _albums.data[albumIndex].contentItem.isMemberLike = true;
    //           updateObj = {
    //             ...updateObj,
    //             albums: _albums,
    //           };
    //           if (data.parentId === _albumDetail.clubAlbumID) {
    //             if (!_albumDetail.isMemberLike) {
    //               _albumDetail.isMemberLike = true;
    //               _albumDetail.likeCount = _albumDetail.likeCount + 1;
    //               updateObj = {
    //                 ...updateObj,
    //                 albumDetail: _albumDetail,
    //               };
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    //   if (data.objType === 'Video' && data.objIndex !== undefined) {
    //     if (_videos.data[data.objIndex]) {
    //       _videos.data[data.objIndex].communityAction.likeCount = likeCount;
    //       _videos.data[data.objIndex].communityAction.isLiked = isLiked;
    //       updateObj = {
    //         ...updateObj,
    //         videos: _videos,
    //       };
    //     }
    //   }
    //   if (data.objType === 'Album') {
    //     // Check and update Like Album in side a Group
    //     const _albumIndex = _albums.data.findIndex(item => item.contentItem.id === data.id);
    //     const _activityIndex = _activity.data.findIndex(item => item.contentItem.id === data.id);
    //     const _groupRecentActivityIndex = _groupRecentActivity.data.findIndex(item => item.contentItem.id === data.id);

    //     if (_albumIndex !== -1) {
    //       _albums.data[_albumIndex].contentItem.likeCount = likeCount;
    //       _albums.data[_albumIndex].contentItem.isMemberLike = isLiked;
    //       updateObj = {
    //         ...updateObj,
    //         albums: _albums,
    //       };
    //     }
    //     // Check and update Like Album in activity
    //     if (_activityIndex !== -1) {
    //       _activity.data[_activityIndex].contentItem.likeCount = likeCount;
    //       _activity.data[_activityIndex].contentItem.isMemberLike = isLiked;
    //       updateObj = {
    //         ...updateObj,
    //         activity: _activity,
    //       };
    //     }
    //     // Check and update Like Album in group recent activity
    //     if (_groupRecentActivityIndex !== -1) {
    //       _groupRecentActivity.data[_groupRecentActivityIndex].contentItem.likeCount = likeCount;
    //       _groupRecentActivity.data[_groupRecentActivityIndex].contentItem.isMemberLike = isLiked;
    //       updateObj = {
    //         ...updateObj,
    //         groupRecentActivity: _groupRecentActivity,
    //       };
    //     }
    //     // Check and update Like Album in album detail
    //     if (data.id === _albumDetail.clubAlbumID) {
    //       _albumDetail.isMemberLike = isLiked;
    //       _albumDetail.likeCount = likeCount;
    //       if (_albumDetail.communityAction) {
    //         _albumDetail.communityAction.likeCount = likeCount;
    //         _albumDetail.communityAction.isLiked = isLiked;
    //       }
    //       updateObj = {
    //         ...updateObj,
    //         albumDetail: _albumDetail,
    //       };
    //     }
    //   }
    //   return state.merge({ ...updateObj });
    // }
    case types.UPDATE_MEDIA_LIKE_SUCCESS: {
      const { data } = action;

      // 1. Tính toán giá trị chung trước
      const isLiked = !data.isLiked;
      const likeCount = data.isLiked ? data.likeCount - 1 : data.likeCount + 1;

      let updateObj: Partial<IGroupState> = {};

      // --- LOGIC CHO POST ---
      if (data.parentType === 'Post') {
        // Chỉ lấy ra và deep clone những thứ cần thiết cho Post
        const _activity = state.activity.asMutable({ deep: true });
        const _groupRecentActivity = state.groupRecentActivity.asMutable({ deep: true });
        const _postDetail = state.postDetail.asMutable({ deep: true });

        // Update trong Group Recent Activity
        const groupRecentActivityIndex =
          _groupRecentActivity?.data?.findIndex(item => (item.contentItem as IGroupContentItem)?.id === data.parentId) ?? -1;
        if (groupRecentActivityIndex !== -1 && _groupRecentActivity) {
          const targetPost = _groupRecentActivity.data[groupRecentActivityIndex].contentItem as IGroupContentItem;
          if (targetPost && targetPost.media[data.objIndex]) {
            if (targetPost.media[data.objIndex].communityAction) {
              targetPost.media[data.objIndex].communityAction!.isLiked = isLiked;
              targetPost.media[data.objIndex].communityAction!.likeCount = likeCount;
            }

            targetPost.likeCount = targetPost.isMemberLike ? targetPost.likeCount - 1 : targetPost.likeCount + 1;
            targetPost.isMemberLike = isLiked;
          }
          updateObj.groupRecentActivity = _groupRecentActivity;
        }

        // Update trong Activity
        const activityIndex = _activity?.data?.findIndex(item => (item.contentItem as IGroupContentItem)?.id === data.parentId) ?? -1;
        if (activityIndex !== -1 && _activity) {
          const targetPost = _activity.data[activityIndex].contentItem as IGroupContentItem;
          if (targetPost && targetPost.media[data.objIndex]) {
            targetPost.media[data.objIndex].communityAction!.isLiked = isLiked;
            targetPost.media[data.objIndex].communityAction!.likeCount = likeCount;

            targetPost.likeCount = targetPost.isMemberLike ? targetPost.likeCount - 1 : targetPost.likeCount + 1;
            targetPost.isMemberLike = isLiked;
          }
          updateObj.activity = _activity;
        }

        // Update trong Post Detail
        if (_postDetail?.contentItem?.id?.toString() === data.parentId.toString()) {
          let mediaIndex = data.objIndex;
          if (!mediaIndex || mediaIndex < 0) {
            mediaIndex = _postDetail.contentItem?.media?.findIndex(itm => itm.id === data.id);
          }

          if (
            _postDetail.contentItem &&
            _postDetail.contentItem.media?.[mediaIndex] &&
            _postDetail.contentItem.media[mediaIndex].communityAction
          ) {
            _postDetail.contentItem.media[mediaIndex].communityAction!.likeCount = likeCount;
            _postDetail.contentItem.media[mediaIndex].communityAction!.isLiked = isLiked;
          }

          if (isLiked && _postDetail.contentItem) {
            _postDetail.contentItem.likeCount = _postDetail.contentItem.isMemberLike
              ? _postDetail.contentItem.likeCount
              : (_postDetail.contentItem.likeCount || 0) + 1;
            _postDetail.contentItem.isMemberLike = true;
          }
          updateObj.postDetail = _postDetail;
        }
      }

      // --- LOGIC CHO PHOTO ---
      if (data.objType === 'Photo' && data.objIndex !== undefined) {
        // Deep clone Photos
        const _photos = state.photos.asMutable({ deep: true });

        if (_photos.data[data.objIndex] && _photos.data[data.objIndex].communityAction) {
          _photos.data[data.objIndex].communityAction!.likeCount = likeCount;
          _photos.data[data.objIndex].communityAction!.isLiked = isLiked;
          updateObj.photos = _photos;
        }

        // Logic update Album cha của Photo đó (nếu có)
        if (data.parentId) {
          // Lưu ý: Nếu user vừa like Post xong like Photo, ta cần đảm bảo state không bị conflict.
          // Ở đây ta init mới từ state gốc vì Post và Photo thường không đi chung 1 action.
          const _albums = state.albums.asMutable({ deep: true });
          const _albumDetail = state.albumDetail.asMutable({ deep: true });

          if (_albums) {
            const albumIndex = _albums.data.findIndex(item => (item.contentItem as IGroupContentItem).id == data.parentId);
            if (albumIndex > -1) {
              // Check logic: Chỉ tăng like album nếu chưa like
              if (!(_albums.data[albumIndex].contentItem as IGroupContentItem)?.isMemberLike) {
                (_albums.data[albumIndex].contentItem as IGroupContentItem).likeCount += 1;
                (_albums.data[albumIndex].contentItem as IGroupContentItem).isMemberLike = true;
                updateObj.albums = _albums;

                // Check update Album Detail
                if (_albumDetail && data.parentId === _albumDetail.clubAlbumID) {
                  if (!_albumDetail.isMemberLike) {
                    _albumDetail.isMemberLike = true;
                    _albumDetail.likeCount += 1;
                    updateObj.albumDetail = _albumDetail;
                  }
                }
              }
            }
          }
        }
      }

      // --- LOGIC CHO VIDEO ---
      if (data.objType === 'Video' && data.objIndex !== undefined) {
        const _videos = state.videos.asMutable({ deep: true });
        if (_videos && _videos.data[data.objIndex] && _videos.data[data.objIndex].communityAction) {
          _videos.data[data.objIndex].communityAction!.likeCount = likeCount;
          _videos.data[data.objIndex].communityAction!.isLiked = isLiked;
          updateObj.videos = _videos;
        }
      }

      // --- LOGIC CHO ALBUM ---
      if (data.objType === 'Album') {
        const _albums = updateObj.albums || state.albums.asMutable({ deep: true });
        const _activity = updateObj.activity || state.activity.asMutable({ deep: true });
        const _groupRecentActivity = updateObj.groupRecentActivity || state.groupRecentActivity.asMutable({ deep: true });
        const _albumDetail = updateObj.albumDetail || state.albumDetail.asMutable({ deep: true });
        // Update Albums List
        if (_albums) {
          const _albumIndex = _albums.data.findIndex(item => (item.contentItem as IGroupContentItem)?.id === data.id);
          if (_albumIndex !== -1) {
            (_albums.data[_albumIndex].contentItem as IGroupContentItem).likeCount = likeCount;
            (_albums.data[_albumIndex].contentItem as IGroupContentItem).isMemberLike = isLiked;
            updateObj.albums = _albums;
          }
        }

        // Update Activity
        if (_activity) {
          const _activityIndex = _activity.data.findIndex(item => (item.contentItem as IGroupContentItem)?.id === data.id);
          if (_activityIndex !== -1) {
            (_activity.data[_activityIndex].contentItem as IGroupContentItem).likeCount = likeCount;
            (_activity.data[_activityIndex].contentItem as IGroupContentItem).isMemberLike = isLiked;
            updateObj.activity = _activity;
          }
        }

        // Update Group Recent Activity
        if (_groupRecentActivity) {
          const _groupRecentActivityIndex = _groupRecentActivity.data.findIndex(
            item => (item.contentItem as IGroupContentItem)?.id === data.id
          );
          if (_groupRecentActivityIndex !== -1) {
            (_groupRecentActivity.data[_groupRecentActivityIndex].contentItem as IGroupContentItem).likeCount = likeCount;
            (_groupRecentActivity.data[_groupRecentActivityIndex].contentItem as IGroupContentItem).isMemberLike = isLiked;
            updateObj.groupRecentActivity = _groupRecentActivity;
          }
        }

        // Update Album Detail
        if (_albumDetail && data.id === _albumDetail.clubAlbumID) {
          _albumDetail.isMemberLike = isLiked;
          _albumDetail.likeCount = likeCount;
          if (_albumDetail.communityAction) {
            _albumDetail.communityAction.likeCount = likeCount;
            _albumDetail.communityAction.isLiked = isLiked;
          }
          updateObj.albumDetail = _albumDetail;
        }
      }

      return state.merge(updateObj);
    }
    case types.PATCH_DELETE_EVENT_SUCCESS: {
      const { clubEvt, clubPastEvt } = Immutable.asMutable(state);
      return state.merge({
        clubEvt: clubEvt.filter(item => item.eventId !== action.params.eventId),
        clubPastEvt: clubPastEvt.filter(item => item.eventId !== action.params.eventId),
      });
    }
    case types.POST_CREATE_EVENT_INTEREST_SUCCESS:
    case types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS: {
      const { clubEvt, clubPastEvt } = Immutable.asMutable(state);
      const { from, id, isUnInterest, type } = action.params;
      let index = action.params.index;
      if (from === EVENT_TYPE.CLUB_DETAIL || from === EVENT_TYPE.EVENT_DETAIL || type === EVENT_TYPE.GROUP_POST_EVENT) {
        const existsEventInClub = clubEvt.find(evt => evt.eventId === id);
        if (!index) {
          index = clubEvt.findIndex(evt => evt.eventId === id);
        }
        const existsEventInClubPast = clubPastEvt.find(evt => evt.eventId === id);
        if (existsEventInClub && index !== -1) {
          const { interestCount } = existsEventInClub;
          state = state.setIn(['clubEvt', index, 'hasExpressInterest'], !isUnInterest);
          state = state.setIn(['clubEvt', index, 'interestCount'], isUnInterest ? interestCount - 1 : interestCount + 1);
        }
        if (existsEventInClubPast && index !== -1) {
          const { interestCount } = existsEventInClubPast;
          state = state.setIn(['clubPastEvt', index, 'hasExpressInterest'], !isUnInterest);
          state = state.setIn(['clubPastEvt', index, 'interestCount'], isUnInterest ? interestCount - 1 : interestCount + 1);
        }

        // const dataMerge = {};
        const { groupRecentActivity } = state;
        const indexsOfGroupActivities: number[] = [];
        groupRecentActivity.data
          .asMutable()
          .forEach(
            (e, index) =>
              ((e.typeId === TYPE.ADDED.EventAdd && (e.contentItem as unknown as IContentItemEvent)?.id === id) ||
                (e.typeId === TYPE.ClubPost && (e.contentItem as unknown as IGroupContentItem)?.event?.[0].eventId === id)) &&
              indexsOfGroupActivities.push(index)
          );
        let newGroupActivity = groupRecentActivity.data.asMutable();
        let interestCount = 1;
        if (action.type === types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS) {
          interestCount = -1;
        }
        if (indexsOfGroupActivities.length > 0) {
          for (let i = 0; i < indexsOfGroupActivities.length; i++) {
            const indexOfActive = indexsOfGroupActivities[i];
            newGroupActivity = newGroupActivity.map((i, index) => {
              if (index === indexOfActive) {
                if (i.typeId === TYPE.ADDED.EventAdd) {
                  const contentItem = i.contentItem?.asMutable() as IContentItemEvent;
                  return i.merge({
                    ...i,
                    contentItem: {
                      ...contentItem,
                      hasExpressInterest: !isUnInterest,
                      interestCount: contentItem?.interestCount + interestCount,
                    },
                  });
                }
                const contentItem = i.contentItem?.asMutable() as IGroupContentItem;
                return i.merge({
                  ...i,
                  contentItem: {
                    ...contentItem,
                    event: [
                      {
                        ...contentItem.event![0],
                        hasExpressInterest: !isUnInterest,
                        interestCount: contentItem.event![0].interestCount + interestCount,
                      },
                    ],
                  },
                });
              }
              return i;
            });
          }
        }

        if (newGroupActivity.length > 0) {
          state = state.setIn(['groupRecentActivity', 'data'], newGroupActivity);
          // dataMerge.groupRecentActivity = {
          //   ...groupRecentActivity,
          //   data: newGroupActivity,
          // };
        }

        const { postDetail, activity } = Immutable.asMutable(state);
        const indexsOfGroup: number[] = [];
        activity.data.forEach(
          (e, index) =>
            ((e.typeId === TYPE.ADDED.EventAdd && (e.contentItem as unknown as IContentItemEvent).id === id) ||
              (e.typeId === TYPE.ClubPost && (e.contentItem as unknown as IGroupContentItem)?.event?.[0].eventId === id)) &&
            indexsOfGroup.push(index)
        );
        let newActivity = activity.data.asMutable();
        if (indexsOfGroup.length > 0) {
          for (let i = 0; i < indexsOfGroup.length; i++) {
            const indexOfActive = indexsOfGroup[i];
            newActivity = newActivity.map((item, index) => {
              if (index === indexOfActive) {
                if (item.typeId === TYPE.ADDED.EventAdd) {
                  return item.merge({
                    ...item,
                    contentItem: {
                      ...item.contentItem,
                      hasExpressInterest: !isUnInterest,
                      interestCount: (item.contentItem as unknown as IContentItemEvent).interestCount + interestCount,
                    },
                  });
                }
                const itemContent = item.contentItem as unknown as IGroupContentItem;
                if (itemContent.event) {
                  return item.merge({
                    ...item,
                    contentItem: {
                      ...itemContent,
                      event: [
                        {
                          ...itemContent.event[0],
                          hasExpressInterest: !isUnInterest,
                          interestCount: itemContent.event[0].interestCount + interestCount,
                        },
                      ],
                    },
                  });
                }
              }
              return item;
            });
          }
        }

        if (newActivity.length > 0) {
          state = state.setIn(['activity', 'data'], newActivity);
          // dataMerge.activity = {
          //   ...activity,
          //   data: newActivity,
          // };
        }

        if ((postDetail.contentItem?.event as IEventUser)?.eventId === id) {
          state = state.setIn(['postDetail', 'contentItem', 'event', 'hasExpressInterest'], !isUnInterest);
          state = state.setIn(
            ['postDetail', 'contentItem', 'event', 'interestCount'],
            (postDetail.contentItem.event as IEventUser).interestCount + interestCount
          );
          //
          // dataMerge.postDetail = {
          //   ...postDetail,
          //   contentItem: {
          //     ...postDetail.contentItem,
          //     event: {
          //       ...postDetail.contentItem.event,
          //       hasExpressInterest: !isUnInterest,
          //       interestCount: postDetail.contentItem.event.interestCount + interestCount,
          //     },
          //   },
          // };
        }

        // state = state.merge(dataMerge);
      }

      return state;
    }
    case types.GET_POST_COMMENT_SUCCESS: {
      const { postDetail } = Immutable.asMutable(state);
      const { data, paginationInfo } = action.params;
      const updateObj = {
        postDetail: {
          ...postDetail,
          paginationInfoComments: paginationInfo,
          comments: !paginationInfo.page || paginationInfo.page < 2 ? data : [...postDetail.comments.asMutable(), ...data],
          isLoadingComments: false,
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_ALBUM_COMMENT_SUCCESS: {
      const { albumDetail } = Immutable.asMutable(state);
      const { data, paginationInfo } = action.params;
      const updateObj = {
        albumDetail: {
          ...albumDetail,
          paginationInfoComments: paginationInfo,
          comments: !paginationInfo.page || paginationInfo.page < 2 ? data : [...albumDetail.comments.asMutable(), ...data],
          isLoadingComments: false,
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_POST_LIKE_USERS_SUCCESS: {
      const { postDetail } = Immutable.asMutable(state);
      const { data, paginationInfo } = action.params;
      const likeUsers = postDetail.likeUsers ? postDetail.likeUsers.asMutable() : [];
      const updateObj = {
        postDetail: {
          ...postDetail,
          paginationInfoUsers: paginationInfo,
          likeUsers: !paginationInfo.page || paginationInfo.page < 2 ? data : [...likeUsers, ...data],
          isLoadingLikeUsers: false,
        },
      };
      return state.merge({ ...updateObj });
    }
    // case types.POST_CREATE_POST_COMMENT_SUCCESS: {
    //   const { postDetail, activity, groupRecentActivity } = Immutable.asMutable(state);
    //   const _activity = JSON.parse(JSON.stringify(activity));
    //   const _postDetail = JSON.parse(JSON.stringify(postDetail));
    //   const _groupRecentActivity = JSON.parse(JSON.stringify(groupRecentActivity));
    //   const { commentParentID, objIndex } = action.params;
    //   const data = action.data;
    //   let updateObj = {};
    //   if (commentParentID) {
    //     let commentIndex = _postDetail.comments.findIndex(item => item.commentId === commentParentID);
    //     let repliesData = _postDetail.comments[commentIndex].replies || [];
    //     _postDetail.comments[commentIndex].replies = [data, ...repliesData];
    //   } else {
    //     _postDetail.comments = [data, ..._postDetail.comments];
    //   }
    //   let replyCount = _postDetail.contentItem.replyCount;
    //   replyCount = replyCount + 1;
    //   _postDetail.contentItem.replyCount = replyCount;
    //   // Update Post comment count in activity
    //   if (_activity.data[objIndex]?.contentItem?.id === _postDetail.contentItem.id) {
    //     _activity.data[objIndex].contentItem.replyCount = replyCount;
    //   } else {
    //     let index = _activity.data.findIndex(item => item.contentItem.id === _postDetail.contentItem.id);
    //     if (index !== -1) {
    //       _activity.data[index].contentItem.replyCount = replyCount;
    //     }
    //   }
    //   // Update Post comment count in group recent activity
    //   if (_groupRecentActivity.data[objIndex]?.contentItem?.id === _postDetail.contentItem.id) {
    //     _groupRecentActivity.data[objIndex].contentItem.replyCount = replyCount;
    //   } else {
    //     let index = _groupRecentActivity.data.findIndex(item => item.contentItem.id === _postDetail.contentItem.id);
    //     if (index !== -1) {
    //       _groupRecentActivity.data[index].contentItem.replyCount = replyCount;
    //     }
    //   }
    //   updateObj = {
    //     postDetail: { ..._postDetail },
    //     activity: _activity,
    //     groupRecentActivity: _groupRecentActivity,
    //   };
    //   return state.merge({ ...updateObj });
    // }
    case types.POST_CREATE_POST_COMMENT_SUCCESS: {
      const { commentParentID, objIndex } = action.params;
      const data = action.data; // Ideally, type this as IComment if available

      // 1. Handle Post Detail
      // postDetail is typed as IPostDetail (or similar) from your state
      const postDetail = state.postDetail.asMutable({ deep: true });

      if (commentParentID) {
        const commentIndex = postDetail.comments.findIndex(item => item.commentId === commentParentID);

        if (commentIndex !== -1) {
          const parentComment = postDetail.comments[commentIndex];
          const currentReplies = parentComment.replies || [];
          parentComment.replies = [data, ...currentReplies];
        }
      } else {
        postDetail.comments = [data, ...(postDetail.comments || [])];
      }

      // Update Count
      const newReplyCount = (postDetail.contentItem.replyCount || 0) + 1;
      postDetail.contentItem.replyCount = newReplyCount;

      const targetId = postDetail.contentItem.id;

      // 2. Strongly Typed Helper for List Updates
      const updateFeedList = (listState: ImmutableObject<IGroupActivity | IRecentActivity>) => {
        if (!listState || !listState.data) return listState;

        // Check exact objIndex
        if ((listState.data[objIndex]?.contentItem?.asMutable() as IGroupContentItem)?.id === targetId) {
          return listState.setIn(['data', `${objIndex}`, 'contentItem', 'replyCount'], newReplyCount);
        }

        // Fallback findIndex
        const foundIndex = listState.data.findIndex((item: Feed) => (item.contentItem as IGroupContentItem)?.id === targetId);

        if (foundIndex !== -1) {
          return listState.setIn(['data', `${foundIndex}`, 'contentItem', 'replyCount'], newReplyCount);
        }

        return listState;
      };

      return state.merge({
        postDetail: postDetail,
        activity: updateFeedList(state.activity),
        groupRecentActivity: updateFeedList(state.groupRecentActivity),
      });
    }

    // case types.POST_DELETE_POST_COMMENT_SUCCESS: {
    //   const { postDetail, activity, groupRecentActivity } = Immutable.asMutable(state);
    //   const _activity = JSON.parse(JSON.stringify(activity));
    //   const _postDetail = JSON.parse(JSON.stringify(postDetail));
    //   const _groupRecentActivity = JSON.parse(JSON.stringify(groupRecentActivity));
    //   const { commentIndex, parentIndex, objIndex, commentId } = action.params;
    //   try {
    //     let updateObj = {};
    //     //
    //     let replyCount = _postDetail.contentItem.replyCount;
    //     if (_postDetail.comments) {
    //       if (parentIndex !== null && parentIndex !== undefined) {
    //         replyCount = replyCount - 1;
    //         _postDetail.comments[parentIndex].replies = _postDetail.comments[parentIndex].replies.filter(c => c.commentId !== commentId);
    //       } else {
    //         // handle remove count of replies if comment has replies
    //         const comment = _postDetail.comments.find(c => c.commentId === commentId);
    //         let count = 1;
    //         if (comment?.replies?.length > 0) {
    //           count += comment.replies.length;
    //         }
    //         replyCount = replyCount - count;
    //         _postDetail.comments = _postDetail.comments.filter(c => c.commentId !== commentId);
    //       }
    //     } else {
    //       replyCount = replyCount - 1;
    //     }
    //     _postDetail.contentItem.replyCount = replyCount;
    //     // Update Post comment count in activity
    //     if (_activity.data[objIndex]?.contentItem?.id === _postDetail.contentItem.id) {
    //       _activity.data[objIndex].contentItem.replyCount = replyCount;
    //     } else {
    //       let index = _activity.data.findIndex(item => item.contentItem.id === _postDetail.contentItem.id);
    //       if (index !== -1) {
    //         _activity.data[index].contentItem.replyCount = replyCount;
    //       }
    //     }
    //     // Update Post comment count in group recent activity
    //     if (_groupRecentActivity.data[objIndex]?.contentItem?.id === _postDetail.contentItem.id) {
    //       _groupRecentActivity.data[objIndex].contentItem.replyCount = replyCount;
    //     } else {
    //       let index = _groupRecentActivity.data.findIndex(item => item.contentItem.id === _postDetail.contentItem.id);
    //       if (index !== -1) {
    //         _groupRecentActivity.data[index].contentItem.replyCount = replyCount;
    //       }
    //     }
    //     updateObj = {
    //       postDetail: { ..._postDetail },
    //       activity: _activity,
    //       groupRecentActivity: _groupRecentActivity,
    //     };
    //     return state.merge({ ...updateObj });
    //   } catch (error) {
    //     console.log('error in POST_DELETE_POST_COMMENT_SUCCESS', error);
    //     return state;
    //   }
    // }
    case types.POST_DELETE_POST_COMMENT_SUCCESS: {
      const { commentId, parentIndex, objIndex } = action.params;

      // 1. Clone postDetail for manipulation
      const postDetail = state.postDetail.asMutable({ deep: true });

      // 2. Get current replyCount (ensure it's a number)
      let replyCount: number = postDetail.contentItem.replyCount || 0;

      // 3. Handle Comment/Reply deletion logic
      if (postDetail.comments) {
        if (parentIndex !== null && parentIndex !== undefined) {
          // CASE: Delete Reply
          replyCount -= 1;
          const parentComment = postDetail.comments[parentIndex];
          if (parentComment?.replies) {
            parentComment.replies = parentComment.replies.filter((c: any) => c.commentId !== commentId);
          }
        } else {
          // CASE: Delete Original Comment
          const commentToDelete = postDetail.comments.find((c: any) => c.commentId === commentId);

          let countToRemove = 1;
          // Logic: If comment has replies, subtract the number of replies as well
          if (commentToDelete?.replies && commentToDelete.replies.length > 0) {
            countToRemove += commentToDelete.replies.length;
          }

          replyCount -= countToRemove;
          postDetail.comments = postDetail.comments.filter((c: any) => c.commentId !== commentId);
        }
      } else {
        replyCount = Math.max(0, replyCount - 1);
      }

      // Update replyCount in postDetail
      postDetail.contentItem.replyCount = replyCount;
      const targetId = postDetail.contentItem.id;

      const updateListCount = (listState: ImmutableObject<IGroupActivity | IRecentActivity>) => {
        if (!listState || !listState.data) return listState;

        // Prioritize checking objIndex first (Original logic)
        if ((listState.data[objIndex]?.contentItem?.asMutable() as IGroupContentItem)?.id === targetId) {
          return listState.setIn(['data', `${objIndex}`, 'contentItem', 'replyCount'], replyCount);
        }

        const foundIndex = listState.data.findIndex((item: Feed) => (item.contentItem as IGroupContentItem)?.id === targetId);

        if (foundIndex !== -1) {
          return listState.setIn(['data', `${foundIndex}`, 'contentItem', 'replyCount'], replyCount);
        }

        return listState;
      };

      return state.merge({
        postDetail: postDetail,
        activity: updateListCount(state.activity),
        groupRecentActivity: updateListCount(state.groupRecentActivity),
      });
    }
    case types.DELETE_ALBUM_COMMENT_SUCCESS: {
      const { albumDetail } = Immutable.asMutable(state);
      const _albumDetail = albumDetail.asMutable({ deep: true });
      const { commentIndex, parentIndex } = action.params;
      try {
        let data = _albumDetail.comments;
        if (parentIndex !== undefined && parentIndex !== null) {
          data = data[parentIndex]?.replies ? data[parentIndex].replies : data[parentIndex];
        }
        data = data.filter((item, index) => index !== commentIndex);
        if (parentIndex !== undefined && parentIndex !== null) {
          _albumDetail.comments[parentIndex].replies = data;
        } else {
          _albumDetail.comments = data;
        }
        _albumDetail.replyCount = _albumDetail.replyCount - 1;

        const updateObj = {
          albumDetail: { ..._albumDetail },
        };
        return state.merge({ ...updateObj });
      } catch (error) {
        console.log('error in DELETE_ALBUM_COMMENT_SUCCESS', error);
        return state;
      }
    }
    case types.GET_POST_DETAIL_SUCCESS: {
      const { postDetail } = Immutable.asMutable(state);
      let _postDetail = JSON.parse(JSON.stringify(postDetail));
      const { data } = action;
      _postDetail = {
        ..._postDetail,
        ...data,
        replyCount: data.contentItem.replyCount,
        likeCount: data.contentItem.likeCount,
        isMemberLike: data.contentItem.isMemberLike,
      };

      const updateObj = {
        postDetail: {
          ..._postDetail,
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.UPDATE_POST_LIKE_SUCCESS: {
      const { postDetail, activity, groupRecentActivity } = state;
      const { isLiked, objIndex, userInfo } = action.params;
      try {
        let likeCount = 0;
        // Check and update PostDetail
        // If is in post detail
        if (postDetail.contentItem?.id) {
          likeCount = postDetail.contentItem.likeCount || 0;
          state = state.setIn(['postDetail', 'contentItem', 'isMemberLike'], !isLiked);
          state = state.setIn(['postDetail', 'contentItem', 'likeCount'], isLiked ? likeCount - 1 : likeCount + 1);
        } else {
          // Find post in activity and groupRecentActivity
          const postExists =
            activity.data.find(itm => (itm.contentItem as IGroupContentItem)?.id === action.params.id) ||
            groupRecentActivity.data.find(itm => (itm.contentItem as IGroupContentItem)?.id === action.params.id);
          likeCount = (postExists?.contentItem as IGroupContentItem)?.likeCount || 0;
        }
        // Check and update GroupRecentActivity
        let contentItemGroupRecentActivity = groupRecentActivity.data[objIndex]?.contentItem?.asMutable() as IGroupContentItem;
        if (contentItemGroupRecentActivity?.id === action.params.id) {
          // If the post is from group recent activity
          state = state.setIn(
            ['groupRecentActivity', 'data', `${objIndex}`, 'contentItem', 'likeCount'],
            isLiked ? likeCount - 1 : likeCount + 1
          );
          state = state.setIn(['groupRecentActivity', 'data', `${objIndex}`, 'contentItem', 'isMemberLike'], !isLiked);
        } else {
          const index = groupRecentActivity.data.findIndex(item => (item.contentItem as IGroupContentItem)?.id === action.params.id);
          if (index !== -1) {
            // If the post is from another place should find it in activity and update it
            state = state.setIn(
              ['groupRecentActivity', 'data', `${index}`, 'contentItem', 'likeCount'],
              isLiked ? likeCount - 1 : likeCount + 1
            );
            state = state.setIn(['groupRecentActivity', 'data', `${index}`, 'contentItem', 'isMemberLike'], !isLiked);
          }
        }
        // Check and update Activity
        if ((activity.data[objIndex]?.contentItem?.asMutable() as IGroupContentItem)?.id === action.params.id) {
          // it is like post from activity
          state = state.setIn(['activity', 'data', `${objIndex}`, 'contentItem', 'likeCount'], isLiked ? likeCount - 1 : likeCount + 1);
          state = state.setIn(['activity', 'data', `${objIndex}`, 'contentItem', 'isMemberLike'], !isLiked);
        } else {
          // it is like post from group recent activity
          let index = activity.data.findIndex(item => (item.contentItem as IGroupContentItem)?.id === action.params.id);
          if (index !== -1) {
            // If the post is from another place should find it in activity and update it
            state = state.setIn(['activity', 'data', `${index}`, 'contentItem', 'likeCount'], isLiked ? likeCount - 1 : likeCount + 1);
            state = state.setIn(['activity', 'data', `${index}`, 'contentItem', 'isMemberLike'], !isLiked);
          }
        }
        return state;
      } catch (error) {
        return state;
      }
    }
    case types.GET_MORE_REPLIES_SUCCESS: {
      const { commentIndex, page, isHasMoreReply, size, data } = action.params;
      const { postDetail } = state;
      const _postDetail = postDetail.asMutable({ deep: true });
      let updateObj = {};
      if (isHasMoreReply) {
        if (commentIndex !== undefined && commentIndex !== null) {
          const _data = data.items || [];
          const repliesData = _postDetail.comments[commentIndex].replies || [];
          _postDetail.comments[commentIndex].replies = [...repliesData, ..._data];
          _postDetail.comments[commentIndex].isHasMoreReply = _data?.length >= size;
          _postDetail.comments[commentIndex].pageNumber = page;
        }
      } else {
        if (commentIndex !== undefined && commentIndex !== null) {
          _postDetail.comments[commentIndex].replies =
            _postDetail.comments[commentIndex].replies.filter((_: any, index: number) => index < 5) || [];
          _postDetail.comments[commentIndex].isHasMoreReply = true;
          _postDetail.comments[commentIndex].pageNumber = 1;
        }
      }
      updateObj = {
        postDetail: { ..._postDetail },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_MORE_ALBUM_REPLIES_SUCCESS: {
      const { commentIndex, page, isHasMoreReply, size, data } = action.params;
      const { albumDetail } = state;
      const _albumDetail = albumDetail.asMutable({ deep: true });
      let updateObj = {};
      if (isHasMoreReply) {
        if (commentIndex !== undefined && commentIndex !== null) {
          const _data = data.items || [];
          const repliesData = _albumDetail.comments[commentIndex].replies || [];
          _albumDetail.comments[commentIndex].replies = [...repliesData, ..._data];
          _albumDetail.comments[commentIndex].isHasMoreReply = _data?.length >= size;
          _albumDetail.comments[commentIndex].pageNumber = page;
        }
      } else {
        if (commentIndex !== undefined && commentIndex !== null) {
          _albumDetail.comments[commentIndex].replies =
            _albumDetail.comments[commentIndex].replies.filter((_: any, index: number) => index < 5) || [];
          _albumDetail.comments[commentIndex].isHasMoreReply = true;
          _albumDetail.comments[commentIndex].pageNumber = 1;
        }
      }
      updateObj = {
        albumDetail: { ..._albumDetail },
      };
      return state.merge({ ...updateObj });
    }
    case types.UPDATE_POST_COMMENT_LIKE_SUCCESS: {
      const { commentIndex, parentIndex, isLiked } = action.params;
      const { postDetail } = state;
      const _postDetail = postDetail.asMutable({ deep: true });

      let data = JSON.parse(JSON.stringify(_postDetail.comments));
      let updateObj = {};
      if (parentIndex !== undefined && parentIndex !== null) {
        data = data[parentIndex].replies;
      }
      if (commentIndex !== -1) {
        data[commentIndex].isLiked = !isLiked;
        data[commentIndex].likeCount = isLiked ? data[commentIndex].likeCount - 1 : data[commentIndex].likeCount + 1;
        if (parentIndex !== undefined && parentIndex !== null) {
          _postDetail.comments[parentIndex].replies = data;
        } else {
          _postDetail.comments = data;
        }
      }
      updateObj = {
        postDetail: { ..._postDetail },
      };
      return state.merge({ ...updateObj });
    }
    case types.UPDATE_ALBUM_COMMENT_LIKE_SUCCESS: {
      const { commentIndex, parentIndex, isLiked } = action.params;
      const { albumDetail } = state;
      const _albumDetail = albumDetail.asMutable({ deep: true });

      let data = JSON.parse(JSON.stringify(_albumDetail.comments));
      let updateObj = {};
      if (parentIndex !== undefined && parentIndex !== null) {
        data = data[parentIndex].replies;
      }
      if (commentIndex !== -1) {
        data[commentIndex].isLiked = !isLiked;
        data[commentIndex].likeCount = isLiked ? data[commentIndex].likeCount - 1 : data[commentIndex].likeCount + 1;
        if (parentIndex !== undefined && parentIndex !== null) {
          _albumDetail.comments[parentIndex].replies = data;
        } else {
          _albumDetail.comments = data;
        }
      }
      updateObj = {
        albumDetail: { ..._albumDetail },
      };
      return state.merge({ ...updateObj });
    }
    case types.DELETE_POST_SUCCESS: {
      const { id, index } = action.params;
      const { activity } = state;
      const _activity = activity.asMutable({ deep: true });
      let updateObj = {};
      _activity.data = _activity.data.filter(
        (item, index: number) => (item.contentItem as IGroupContentItem)?.id.toString() !== id.toString()
      );
      updateObj = {
        activity: _activity,
      };
      return state.merge({ ...updateObj });
    }
    case types.DELETE_ALBUM_SUCCESS: {
      const { id, index } = action.params;
      const { albums, activity } = state;
      const _albums = albums.asMutable({ deep: true });
      const _activity = activity.asMutable({ deep: true });
      let updateObj = {};
      _albums.data = _albums.data.filter((item, index) => Number((item.contentItem as IGroupContentItem).id) !== Number(id));
      _activity.data = _activity.data.filter((item, index) => (item.contentItem as IGroupContentItem)?.id.toString() !== id.toString());
      updateObj = {
        albums: _albums,
        activity: _activity,
      };
      return state.merge({ ...updateObj });
    }
    case types.UPDATE_MEDIA_UPLOADING_STATE: {
      const { mediaUploading } = state;
      const _mediaUploading: any = mediaUploading.asMutable({ deep: true });
      const id = action.params.id;
      const isVideo = id?.includes('video');
      const isUploading = action.params.isUploading;
      const isFinished = action.params.isFinished;
      let item = _mediaUploading[id] || undefined;
      if (item) {
        _mediaUploading[id] = { ...item, ...action.params };
      }

      if (isUploading) {
        if (isVideo) {
          _mediaUploading.isHaveVideoUploading = true;
        }
        if (isVideo) {
          _mediaUploading.pendingUploadingVideoIds = _mediaUploading.pendingUploadingVideoIds.filter((_id: string) => _id !== id);
        } else {
          _mediaUploading.pendingUploadingPhotoIds = _mediaUploading.pendingUploadingPhotoIds.filter((_id: string) => _id !== id);
          _mediaUploading.isHavePhotoUploading = true;
        }
        _mediaUploading.pendingUploadingMediaIds = _mediaUploading.pendingUploadingMediaIds.filter((_id: string) => _id !== id);
        _mediaUploading.isHaveMediaUploading = true;
      }
      if (isFinished) {
        _mediaUploading.pendingUploadingCount = _mediaUploading.pendingUploadingCount - 1;

        if (isVideo) {
          _mediaUploading.isHaveVideoUploading = false;
        } else {
          _mediaUploading.isHavePhotoUploading = false;
        }
        _mediaUploading.isHaveMediaUploading = false;
      }
      return state.merge({ mediaUploading: _mediaUploading });
    }
    case types.INIT_MEDIA_UPLOADING_STATE: {
      const { mediaUploading } = state;
      return state.merge({ mediaUploading: { ...mediaUploading.asMutable(), ...action.data } });
    }
    case types.GET_ALBUM_DETAIL_SUCCESS: {
      const { albumDetail } = state;
      let _albumDetail = albumDetail.asMutable({ deep: true });
      const { data } = action;
      _albumDetail = {
        ..._albumDetail,
        ...data,
        replyCount: data.communityAction.commentCount,
        likeCount: data.communityAction.likeCount,
        isMemberLike: data.communityAction.isLiked,
      };

      const updateObj = {
        albumDetail: {
          ..._albumDetail,
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.UPDATE_ALBUM_DETAIL_SUCCESS: {
      const { albumDetail, activity, albums } = Immutable.asMutable(state);
      let _albumDetail = albumDetail.asMutable({ deep: true });
      const { data } = action;
      _albumDetail = {
        ..._albumDetail,
        ...data,
      };
      const updateObj = {
        albumDetail: {
          ..._albumDetail,
        },
        activity: {
          ...activity,
          data: activity.data.map(item =>
            Number((item.contentItem?.asMutable() as IGroupContentItem)?.id) === action.data.clubAlbumID
              ? { ...item, contentItem: { ...item.contentItem, title: action.data.title } }
              : item
          ),
        },
        albums: {
          ...albums,
          data: albums.data.map(item => {
            if ((item.contentItem?.asMutable() as IGroupContentItem)?.id === Number(action.data.clubAlbumID)) {
              return { ...item, contentItem: { ...item.contentItem, title: action.data.title } };
            }
            return item;
          }),
        },
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_CLUB_LIST_CAN_BE_INVITED_SUCCESS: {
      const { data } = action;
      return state.merge({ groupsCanShare: data });
    }
    case types.GET_JOIN_USER_REQUEST_SUCCESS: {
      const { joinedRequest } = Immutable.asMutable(state);
      const _joinedRequest = joinedRequest.asMutable({ deep: true });
      _joinedRequest.data = action.params.data;
      _joinedRequest.paginationInfo = action.params.paginationInfo;
      _joinedRequest.totalRequests = action.params.totalRequests;
      return state.merge({ joinedRequest: _joinedRequest });
    }
    case types.GET_RECOMMENDED_GROUP_REQUEST: {
      return state.set('isLoadingRecommendedGroups', true);
    }
    case types.GET_RECOMMENDED_GROUP_SUCCESS: {
      return state.set('recommendedGroups', action.data).set('isLoadingRecommendedGroups', false).set('isLoadedRecommendedGroups', true);
    }
    case types.GET_RECOMMENDED_GROUP_FAILED: {
      return state.set('isLoadingRecommendedGroups', false);
    }
    case types.UPDATE_GROUP_MEMBER_SUCCESS: {
      const { clubId, userIds, isRemove, isRequest } = action.params;
      const count = isRemove && isRequest ? 0 : userIds.length * (isRemove ? -1 : 1);

      // Helper to preserve original arithmetic behavior
      const getNewCount = (current: number) => (isRemove ? current - count : current + count);

      // 1. Update Popular Search
      const popIndex = state.dataPopularSearch.findIndex(item => item.clubID.toString() === clubId.toString());
      if (popIndex !== -1) {
        state = state.setIn(
          ['dataPopularSearch', popIndex, 'clubMemberCount'],
          getNewCount(state.dataPopularSearch[popIndex].clubMemberCount)
        );
      }

      // 2. Update Desktop Popular Search
      const deskPopIndex = state.dataDesktopPopularSearch.findIndex(item => item.clubID.toString() === clubId.toString());
      if (deskPopIndex !== -1) {
        state = state.setIn(
          ['dataDesktopPopularSearch', deskPopIndex, 'clubMemberCount'],
          getNewCount(state.dataDesktopPopularSearch[deskPopIndex].clubMemberCount)
        );
      }

      // 3. Update My Group
      const myGroupIndex = state.dataMyGroup.findIndex(item => item.clubID.toString() === clubId.toString());
      if (myGroupIndex !== -1) {
        state = state.setIn(['dataMyGroup', myGroupIndex, 'clubMemberCount'], getNewCount(state.dataMyGroup[myGroupIndex].clubMemberCount));
      }

      // 4. Update Joined Request
      if (state.joinedRequest) {
        const decrement = typeof isRequest === 'boolean' ? (isRequest ? count : 0) : count;
        state = state.setIn(['joinedRequest', 'totalRequests'], state.joinedRequest.totalRequests - decrement);

        const newJoinedData = state.joinedRequest.data.filter(item => !userIds.includes(item.userId.toString()));
        state = state.setIn(['joinedRequest', 'data'], newJoinedData);
      }

      // 5. Update Group Detail
      if (state.dataGroupDetail && state.dataGroupDetail.joinedUsers) {
        const joinedUsers = state.dataGroupDetail.joinedUsers;
        const indexDataGroupDetail = joinedUsers.findIndex(item => item.userId.toString() === userIds[0].toString());

        if (indexDataGroupDetail !== -1 && isRemove && !isRequest) {
          // Remove 1 user at index (matching splice(index, 1) logic)
          const newJoinedUsers = joinedUsers.filter((_, idx) => idx !== indexDataGroupDetail);
          state = state.setIn(['dataGroupDetail', 'joinedUsers'], newJoinedUsers);
          state = state.setIn(['dataGroupDetail', 'totalJoinedUser'], state.dataGroupDetail.totalJoinedUser - userIds.length);
        }
      }

      // 6. Update Group Join Request
      if (state.dataGroupJoinRequest && state.dataGroupJoinRequest.length > 0) {
        const newGroupJoinRequest = state.dataGroupJoinRequest.filter(
          item => !(userIds.includes(item.userId.toString()) && item.parentGroup.id.toString() === clubId.toString())
        );

        if (newGroupJoinRequest.length < state.dataGroupJoinRequest.length) {
          state = state.set('dataGroupJoinRequest', newGroupJoinRequest);
          state = state.set('totalGroupJoinRequest', state.totalGroupJoinRequest - count);
        }
      }
      return state;
    }
    case types.PATCH_CLUB_USER_MEMBER_LEVEL_SUCCESS: {
      const { userId, clubMemberType } = action.params;
      const { dataGroupDetail } = state;
      if (!dataGroupDetail || !Array.isArray(dataGroupDetail.joinedUsers)) {
        return state;
      }
      return state.setIn(
        ['dataGroupDetail', 'joinedUsers'],
        dataGroupDetail.joinedUsers.map(user => {
          if (user.userId && user.userId.toString() === userId.toString()) {
            return { ...user, clubMemberType: clubMemberType };
          }
          return user;
        })
      );
    }
    case types.PATCH_CLUB_USER_BAN_POSTING_SUCCESS: {
      const { userId, isBanned } = action.params;
      const { dataGroupDetail } = Immutable.asMutable(state);
      if (!dataGroupDetail || !Array.isArray(dataGroupDetail.joinedUsers)) {
        return state;
      }
      return state.setIn(
        ['dataGroupDetail', 'joinedUsers'],
        dataGroupDetail.joinedUsers.map(user => {
          if (user.userId && user.userId.toString() === userId.toString()) {
            return { ...user, bannedFromPosting: isBanned };
          }
          return user;
        })
      );
    }
    case types.DELETE_CLUB_MEDIA_SUCCESS: {
      const { objType, id } = action.params;
      switch (objType) {
        case 'Video':
          const { videos } = Immutable.asMutable(state);
          const updateVideoObj = {
            videos: {
              data: videos.data.filter(v => v.id !== id),
              paginationInfo: { ...videos.paginationInfo, totalItems: videos.paginationInfo.totalItems - 1 },
            },
          };
          return state.merge({ ...updateVideoObj });

        case 'Photo':
          const { photos } = Immutable.asMutable(state);
          const updatePhotoObj = {
            photos: {
              data: photos.data.filter(v => v.id !== id),
              paginationInfo: { ...photos.paginationInfo, totalItems: photos.paginationInfo.totalItems - 1 },
            },
          };
          return state.merge({ ...updatePhotoObj });

        default:
          return state;
      }
    }

    case types.DELETE_CLUB_COMMENT_SUCCESS: {
      const { voteComments, dataGroupDetail, totalVoteComments } = state;
      const _dataGroupDetail = Immutable.asMutable(dataGroupDetail);
      _dataGroupDetail.rateScore = 0;
      _dataGroupDetail.hasCommented = false;
      const newVoteComments = voteComments.filter(v => v.comment.commentId !== action.id);
      const newTotalVoteComments = totalVoteComments - 1 > 0 ? totalVoteComments - 1 : 0;
      return state.merge({
        voteComments: newVoteComments,
        dataGroupDetail: _dataGroupDetail,
        totalVoteComments: newTotalVoteComments,
      });
    }

    case types.POST_CREATE_UPDATE_VOTE_SUCCESS: {
      const { dataGroupDetail } = state;
      const _dataGroupDetail = Immutable.asMutable(dataGroupDetail);
      _dataGroupDetail.hasRated = true;
      _dataGroupDetail.hasCommented = true;
      _dataGroupDetail.rateScore = action.params.score || 0;
      return state.merge({
        dataGroupDetail: _dataGroupDetail,
      });
    }
    case types.MERGE_DATA_GROUP_NOTIFICATION: {
      return state.merge({ ...action.data });
    }
    case types.GET_GROUP_ALERTS_SUCCESS: {
      const { dataGroupAlerts } = state;
      const { data, paginationInfo } = action;
      const _dataGroupAlerts = dataGroupAlerts.asMutable({ deep: true });
      const updateObj = {
        dataGroupAlerts: paginationInfo.page === 1 ? data : [...data, ..._dataGroupAlerts],
        isLoadingGroupAlerts: false,
        pageNumberGroupAlerts: paginationInfo.page,
        totalGroupAlerts: paginationInfo.total,
        isHasMoreGroupAlerts: data.length < paginationInfo.size,
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_GROUP_ACTIVITIES_NOTIFICATION_SUCCESS: {
      const { dataGroupActivities } = state;
      const { data, paginationInfo } = action;
      const _dataGroupActivities = dataGroupActivities.asMutable({ deep: true });
      const updateObj = {
        dataGroupActivities: paginationInfo.page === 1 ? data : [...data, ..._dataGroupActivities],
        isLoadingGroupActivities: false,
        pageNumberGroupActivities: paginationInfo.page,
        totalGroupActivities: paginationInfo.total,
        isHasMoreGroupActivities: data.length === paginationInfo.size,
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_GROUP_JOIN_REQUEST_NOTIFICATION_SUCCESS: {
      const { dataGroupJoinRequest } = state;
      const { data, paginationInfo } = action;
      const _dataGroupJoinRequest = dataGroupJoinRequest.asMutable({ deep: true });
      const updateObj = {
        dataGroupJoinRequest: paginationInfo.page === 1 ? data : [...data, ..._dataGroupJoinRequest],
        isLoadingGroupJoinRequest: false,
        pageNumberGroupJoinRequest: paginationInfo.page,
        totalGroupJoinRequest: paginationInfo.total,
        isHasMoreGroupJoinRequest: data.length === paginationInfo.size,
      };
      return state.merge({ ...updateObj });
    }

    case types.CREATE_GROUP_SUCCESS: {
      const { dataMyGroup } = state;
      const updateMyGroupObj = {
        dataMyGroup: [action.data, ...dataMyGroup.asMutable()],
      };
      return state.merge({ ...updateMyGroupObj });
    }

    case types.UPDATE_GROUP_SUCCESS: {
      const { dataGroupDetail, dataMyGroup } = state;
      const index = dataMyGroup.findIndex(g => g.clubID === action.data.clubID);
      if (index !== -1) {
        state = state.setIn(['dataMyGroup', `${index}`], { ...dataMyGroup[index], ...action.data });
      }
      state = state.setIn(['dataGroupDetail', 'detail'], { ...(dataGroupDetail.detail || {}), ...action.data });
      return state;
    }

    case types.REMOVE_GROUP_SUCCESS: {
      return state.set(
        'dataMyGroup',
        state.dataMyGroup.filter(g => g.clubID !== action.clubId)
      );
    }

    case types.RESET_POST_DETAIL_DATA_SUCCESS: {
      return state.merge({
        postDetail: initialState.groupState.postDetail,
      });
    }

    case types.UPDATE_BANNER_GROUP_SUCCESS: {
      const index = state.dataMyGroup.findIndex(g => g.clubID === action.clubID);
      if (index !== -1) {
        state = state.setIn(['dataMyGroup', `${index}`, 'banner'], action.data);
      }

      if (state.dataGroupDetail) {
        state = state.setIn(['dataGroupDetail', 'banner'], action.data);
      }

      return state;
    }

    case types.UPDATE_POST_DETAIL_SUCCESS: {
      const { message, postId } = action.data;

      // 1. Update Post Detail
      if (state.postDetail?.contentItem) {
        state = state.setIn(['postDetail', 'contentItem', 'message'], message);
        state = state.setIn(['postDetail', 'contentItem', 'approvalState'], APPROVAL_STATUS.PENDING);
      }

      // 2. Update Activity
      if (state.activity?.data) {
        const activityIndex = state.activity.data.findIndex(item => (item.contentItem as IGroupContentItem).id === Number(postId));
        if (activityIndex !== -1) {
          state = state.setIn(['activity', 'data', `${activityIndex}`, 'contentItem', 'message'], message);
        }
      }

      // 3. Update Albums - mapping message to title
      if (state.albums?.data) {
        const albumIndex = state.albums.data.findIndex(item => (item.contentItem as IGroupContentItem).id === Number(postId));
        if (albumIndex !== -1) {
          state = state.setIn(['albums', 'data', `${albumIndex}`, 'contentItem', 'title'], message);
        }
      }

      return state;
    }
    case types.GET_GROUP_SUGGESTED_USERS_REQUEST: {
      const { page } = action;
      if (page === 1) {
        // Reset to initial state with loading true
        return state.set('suggestedUsers', {
          ...initialState.groupState.suggestedUsers,
          isLoading: true,
        });
      }
      // Load more
      return state.setIn(['suggestedUsers', 'isLoadingMore'], true);
    }
    case types.GET_GROUP_SUGGESTED_USERS_SUCCESS: {
      const { data, paginationInfo } = action;
      const currentData = state.suggestedUsers?.data.asMutable() || [];
      const newData = paginationInfo.page === 1 ? data : [...currentData, ...data];

      const updateObj = {
        data: newData,
        isLoading: false,
        isLoadingMore: false,
        pageNumber: paginationInfo.page,
        total: paginationInfo.total,
        isHasMore: paginationInfo.searchGuid ? data.length === paginationInfo.size : newData.length < paginationInfo.total,
        searchGuid: paginationInfo.searchGuid || '',
      };
      return state.set('suggestedUsers', updateObj);
    }
    case types.UPDATE_GROUP_SUGGESTED_USER_FILTER: {
      const { data } = action;
      const currentFilter = state.suggestedUsersFilter;
      const updateObj = {
        ...currentFilter,
        ...data,
        isHasChangeFilter: data.userName && currentFilter?.isHasChangeFilter ? true : data.isHasChangeFilter,
        isApplyFilter: data.userName && currentFilter?.isApplyFilter ? true : data.isApplyFilter,
      };
      return state.set('suggestedUsersFilter', updateObj);
    }
    case types.RESET_GROUP_SUGGESTED_USER_FILTER: {
      const currentFilter = state.suggestedUsersFilter;
      const updateObj = {
        ...currentFilter,
        memberTypes: currentFilter.defaultMemberTypes,
        minAge: 18,
        maxAge: 99,
        location: {},
        searchRadius: 100,
        isHasChangeFilter: false,
        isApplyFilter: false,
      };
      return state.set('suggestedUsersFilter', updateObj);
    }
    case types.GET_GROUP_CHATS_SUCCESS: {
      const { data, paginationInfo } = action;
      const currentData = state.chats?.data || [];
      const updateObj = {
        data: paginationInfo.page === 1 ? data : [...currentData.asMutable(), ...data],
        pageNumber: paginationInfo.page,
        isHasMore: data.length === paginationInfo.size,
      };
      return state.set('chats', updateObj);
    }
    case types.GET_ALL_GROUP_ACTIVITY_REQUEST: {
      const updateObj = {
        ...state.groupRecentActivity,
        isLoading: true,
        loadedData: false,
      };
      return state.set('groupRecentActivity', updateObj);
    }
    case types.UPDATE_GROUP_ACTIVITY_LOADING: {
      return state.setIn(['groupRecentActivity', 'isLoading'], true);
    }
    case types.RESET_GROUP_ACTIVITY_SUCCESS: {
      return state.set('groupRecentActivity', {
        data: [],
        isLoading: false,
        isHasMore: true,
        pageNumber: 0,
        total: 0,
        loadedData: false,
      });
    }
    case types.RESET_GROUP_INVITE_SUCCESS: {
      return state.set('invitesReceived', {
        data: [],
        isLoading: false,
        page: 0,
        isHasMore: true,
        total: 0,
        loadedData: false,
      });
    }
    case types.GET_ALL_GROUP_ACTIVITY_SUCCESS: {
      const { data, paginationInfo } = action;
      const currentData = state.groupRecentActivity?.data || [];
      const updateObj = {
        data: paginationInfo.page === 1 ? data : [...currentData.asMutable(), ...data],
        pageNumber: paginationInfo.page,
        isHasMore: data.length === paginationInfo.size,
        isLoading: false,
        loadedData: true,
      };
      return state.set('groupRecentActivity', updateObj);
    }
    case types.GET_INVITES_GROUP_RECEIVED_REQUEST: {
      return state.setIn(['invitesReceived', 'isLoading'], true);
    }
    case types.GET_INVITES_GROUP_RECEIVED_FAILED: {
      return state.setIn(['invitesReceived', 'isLoading'], false);
    }
    case types.GET_INVITES_GROUP_RECEIVED_SUCCESS: {
      const { data, paginationInfo } = action;
      const currentData = state.invitesReceived?.data || [];
      const updateObj = {
        data: paginationInfo.page === 1 ? data : [...currentData.asMutable(), ...data],
        isLoading: false,
        page: paginationInfo.page,
        isHasMore: paginationInfo.isHasMore,
        total: paginationInfo.totalItems,
        loadedData: true,
      };
      return state.set('invitesReceived', updateObj);
    }
    case types.DELETE_INVITES_GROUP_RECEIVED_SUCCESS: {
      const { invitesReceived } = state;
      const newData = invitesReceived.data.filter(i => i.inviteId !== action.data.inviteId);
      return state.merge({
        invitesReceived: {
          ...invitesReceived,
          data: newData,
          total: invitesReceived.data.length !== newData.length ? invitesReceived.total - 1 : invitesReceived.total,
        },
      });
    }
    case types.TOGGLE_EVENT_INTEREST_SUCCESS: {
      const { eventId, hasExpressInterest } = action.data;
      const interestDelta = hasExpressInterest ? 1 : -1;

      // 1. Update Post Detail
      if ((state.postDetail?.contentItem?.event as IEventUser)?.eventId === eventId) {
        // Safe check for existence before math
        const currentInterest = (state.postDetail.contentItem.event as IEventUser).interestCount || 0;
        state = state
          .setIn(['postDetail', 'contentItem', 'event', 'hasExpressInterest'], hasExpressInterest)
          .setIn(['postDetail', 'contentItem', 'event', 'interestCount'], currentInterest + interestDelta);
      }

      // 2. Update Activity List
      if (state.activity?.data) {
        const newActivityData = state.activity.data.map(item => {
          const contentItem = item.contentItem as any;
          // Case A: Event Item
          if (item.typeId === TYPE.ADDED.EventAdd && contentItem?.id === eventId) {
            const currentInterest = contentItem.interestCount || 0;
            return item
              .setIn(['contentItem', 'hasExpressInterest'], hasExpressInterest)
              .setIn(['contentItem', 'interestCount'], currentInterest + interestDelta);
          }

          // Case B: Post with Event
          if (item.typeId === TYPE.ClubPost && contentItem?.event?.[0]?.eventId === eventId) {
            const currentInterest = contentItem.event[0].interestCount || 0;
            return item
              .setIn(['contentItem', 'event', '0', 'hasExpressInterest'], hasExpressInterest)
              .setIn(['contentItem', 'event', '0', 'interestCount'], currentInterest + interestDelta);
          }

          return item;
        });

        state = state.setIn(['activity', 'data'], newActivityData);
      }

      return state;
    }
    case types.TOGGLE_EVENT_INTEREST_SUCCESS_GROUP_ACTIVITY: {
      const { eventId, hasExpressInterest } = action.data;
      const interestDelta = hasExpressInterest ? 1 : -1;

      if (state.groupRecentActivity?.data) {
        const newGroupRecentActivityData = state.groupRecentActivity.data.map(item => {
          const contentItem = item.contentItem as any;
          // Case A: Event Item
          if (item.typeId === TYPE.ADDED.EventAdd && contentItem?.id === eventId) {
            const currentInterest = contentItem.interestCount || 0;
            return item
              .setIn(['contentItem', 'hasExpressInterest'], hasExpressInterest)
              .setIn(['contentItem', 'interestCount'], currentInterest + interestDelta);
          }

          // Case B: Post with Event
          if (item.typeId === TYPE.ClubPost && contentItem?.event?.[0]?.eventId === eventId) {
            const currentInterest = contentItem.event[0].interestCount || 0;
            return item
              .setIn(['contentItem', 'event', '0', 'hasExpressInterest'], hasExpressInterest)
              .setIn(['contentItem', 'event', '0', 'interestCount'], currentInterest + interestDelta);
          }

          return item;
        });

        return state.setIn(['groupRecentActivity', 'data'], newGroupRecentActivityData);
      }

      return state;
    }
    case types.GET_SUGGESTED_GROUP_SUCCESS: {
      return state.merge({ suggestedGroups: action.data });
    }
    case types.UPGRADE_PERMISSION_GROUP_DETAIL: {
      const { dataGroupDetail } = Immutable.asMutable(state);
      if (dataGroupDetail) {
        return state.setIn(['dataGroupDetail', 'userGrants'], {
          ...dataGroupDetail.userGrants,
          ...action.data,
        });
      }
      return state;
    }
    case types.UPDATE_GROUP_EVENT_SUCCESS: {
      const { clubPastEvt, clubEvt } = state;
      const newClubPastEvt = clubPastEvt.asMutable();
      const newClubEvt = clubEvt.asMutable();
      const index = action.isEventInThePast
        ? newClubPastEvt.findIndex(e => e.eventId === action.eventData.eventId)
        : newClubEvt.findIndex(e => e.eventId === action.eventData.eventId);
      if (action.isEventInThePast) {
        newClubPastEvt[index] = { ...newClubPastEvt[index], ...action.eventData };
      } else {
        newClubEvt[index] = { ...newClubEvt[index], ...action.eventData };
      }
      return state.merge({ clubPastEvt: newClubPastEvt, clubEvt: newClubEvt });
    }
    case types.GET_USER_CLUB_NEW_USERS: {
      const { data, paginationInfo } = action;
      const { groupJoins } = state;
      const newData = paginationInfo.page === 1 ? data : [...groupJoins.data.asMutable(), ...data];
      const updateObj = {
        data: newData,
        pageNumber: paginationInfo.page,
        isHasMore: newData.length < paginationInfo.totalItems,
        total: paginationInfo.totalItems,
        isLoading: false,
        loadedData: true,
        size: paginationInfo.size,
      };
      return state.setIn(['groupJoins'], updateObj);
    }
    default:
      return state;
  }
}
